module.exports = __webpack_public_path__ + "static/media/banner_resourcesforyou-Primary_School-Social_media_user_guide.d0c75cef.png";